import React from 'react';

const IcBack = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.1014 3.89935C13.4334 4.2313 13.4334 4.76949 13.1014 5.10143L6.20247 12.0004L13.1014 18.8994C13.4334 19.2313 13.4334 19.7695 13.1014 20.1014C12.7695 20.4334 12.2313 20.4334 11.8993 20.1014L4.39935 12.6014C4.0674 12.2695 4.0674 11.7313 4.39935 11.3993L11.8993 3.89935C12.2313 3.5674 12.7695 3.5674 13.1014 3.89935Z'
                fill='#333438'
            />
        </svg>
    );
};

export default IcBack;
